/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import ContractStatusLabel from '../../ContractStatusLabel';
import ContractPickerDates from '../ContractPickerDates';
import ContractPickerNoMaster from '../ContractPickerNoMaster';

import './module.css';

class ContractPickerOption extends Component {
  constructor(props) {
    super(props);

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  handleMouseDown(event) {
    const { option, onSelect } = this.props;

    event.preventDefault();
    event.stopPropagation();

    onSelect(option, event);
  }

  handleMouseEnter(event) {
    const { option, onFocus } = this.props;

    onFocus(option, event);
  }

  handleMouseMove(event) {
    const { isFocused, onFocus } = this.props;

    if (isFocused) {
      return;
    }

    onFocus(this.props.option, event);
  }

  render() {
    const { option, className, children } = this.props;
    const hasMasterTenant = !!option.masterTenantId;

    return (
      <div
        styleName={classNames('contract-picker-option', {
          'has-master': hasMasterTenant
        })}
        className={className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={option.title}
      >
        <strong>{children || option.number}</strong>
        <ContractPickerDates
          startDate={option.startDate}
          endDate={option.endDate}
          showPlan={option.showPlan}
          plan={option.plan}
        />
        <ContractStatusLabel status={option.status} />
        <ContractPickerNoMaster hasMasterTenant={hasMasterTenant} />
      </div>
    );
  }
}

ContractPickerOption.propTypes = {
  option: PropTypes.object.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func
};

export default ContractPickerOption;
